import { forwardRef, useId } from "react";
import { HTMLProps } from "@/types";

type RadioButtonProps = {
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setValue?: (val: string) => void;
} & HTMLProps<"input">;

type Ref = HTMLInputElement;

const RadioButton = forwardRef<Ref, RadioButtonProps>(function (
  { label, name, required, disabled, setValue, onChange, checked, id: idFromProps, value, ...props },
  ref
) {
  const generatedId = useId();
  const id = idFromProps ?? generatedId;

  return (
    <div className="flex items-center gap-2 b-1 border-sand7 rounded-lg bg-white p-2">
      <input
        {...props}
        type="radio"
        ref={ref}
        id={id}
        name={name}
        checked={checked}
        value={value}
        required={required}
        disabled={disabled}
        onChange={(e) => {
          setValue?.(e.target.value);
          onChange?.(e);
        }}
      />
      {label && (
        <label htmlFor={id} className={`text-sm cursor-pointer ${disabled ? "text-gray-400" : "text-black"}`}>
          {label}
        </label>
      )}
    </div>
  );
});

RadioButton.displayName = "RadioButton";
export default RadioButton;
